import React from 'react';
import { createBrowserRouter, createHashRouter } from "react-router-dom";
import AppLayout from '../pages/layout/AppLayout';
import Item from '../pages/MasterForms/Item';
import Supplier from '../pages/MasterForms/Supplier';
import OrderManagementList from '../pages/MasterForms/OrderManagementList';
import AppChangePassword from '../Components/login/AppChangePassword';
import AppLogin from '../Components/login/AppLogin';
import OrderWiseSummary from '../pages/Reports/OrderWiseSummary';
import ItemWiseSummary from '../pages/Reports/ItemWiseSummary';
import ShipmentWiseSummary from '../pages/Reports/ShipmentWiseSummary';
import POWiseSummary from '../pages/Reports/POWiseSummary';
import Dashboard from '../pages/dashboard/dashboard';
import OutwardRemittance from '../pages/Reports/OutwardRemittance';
import OrderReport from '../pages/Reports/OrderReport';
//import SalesTarget from '../pages/Employee/SalesTarget';
//import EmployeeMonthlyTarget from '../pages/Employee/EmployeeMonthlyTarget';
//import EmployeeForm from '../pages/Employee/EmployeeForm';
//import EmployeeFYTarget from "../pages/Employee/EmployeeFYTarget";
//import EmployeeList from "../pages/Employee/EmployeeList";
//import AppLogin from '../Components/login/AppLogin';
//import OutstandingImport from '../pages/Outstanding/OutstandingImport';
//import SalesInvoiceList from '../pages/dashboard/SalesInvoiceList';
//import AppForgotPassword from '../Components/login/AppForgotPassword';

import HomePage from '../pages/HomePage';
import ProductPage from '../pages/ProductPage';
import ProductFilesPage from '../pages/ProductFilesPage';
import ManageProductPage from '../pages/ManageProductPage';
import SparesManagerPage from '../pages/SpareManagerPage';
import SparePublisherPage from '../pages/SparePublisherPage';
import CheckoutPage from '../pages/CheckoutPage';
import ProductListPage from '../pages/ProductListPage';
import UserListPage from '../pages/UserListPage';
import ManageUserPage from '../pages/ManageUserPage';
import MyRequestPage from '../pages/MyRequestPage';
import MyRequestDetailPage from '../pages/MyRequestDetailPage';
import ChangePasswordPage from '../pages/ChangePasswordPage';
import { RoleGuard, UserRoleGuard } from './RoleGuard';
import ProductImagePage from '../pages/ProductImagePage';
import ExpenseRequestApprovalPage from '../pages/ExpenseRequestApprovalPage';
import MyExpenseRequestPage from '../pages/MyExpenseRequestPage';
import ExpenseApprovalListPage from '../pages/ExpenseApprovalListPage';
import NewExpenseRequestPage from '../pages/NewExpenseRequestPage';
import ExpenseReportPage from '../pages/ExpenseReportPage';
import ExpenseAdminApprovalPage from '../pages/ExpenseRequestAdminApprovalPage';
import DashboardPage from '../pages/DashboardPage';
import NewServiceRequestPage from '../pages/ServiceRequest/NewServiceRequest';
import MyServiceRequestPage from '../pages/ServiceRequest/MyServiceRequestPage';
import ServiceRequestView from '../pages/ServiceRequest/ServiceRequestDetailPage';
import ServiceRequestApprovalPage from '../pages/ServiceRequest/ServiceRequestApprovalPage';
import ServiceRequestViewBkp from '../pages/ServiceRequest/MyServiceRequestDetailPage';
import ServiceRequestApprovalListPage from '../pages/ServiceRequest/ServiceRequestApprovalListPage';
import ServiceRequestReportPage from '../pages/ServiceRequest/ServiceRequestReportPage';
import OrderTrackingPage from '../pages/OrderTracking/OrderTrackingPage';
import NewMasterRequestPage from '../pages/MasterRequest/NewMasterRequest';
import MyMasterRequestPage from '../pages/MasterRequest/MyMasterRequestPage';
import MasterRequestView from '../pages/MasterRequest/MasterRequestDetailPage';
import MasterRequestApprovalListPage from '../pages/MasterRequest/MasterRequestApprovalListPage';
import MasterRequestReportPage from '../pages/MasterRequest/MasterRequestReportPage';

export default createBrowserRouter([
    {
        path: "/",
        element: <AppLayout />,
        children: [
            {
                path: "/",
                element: <DashboardPage />,
            },
            {
                path: "/Catalog",
                element: <HomePage />,
            },
            {
                path: "/Product/:subGroupId",
                element: <ProductPage />,
            },
            {
                path: "/ProductList",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ProductListPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/ProductFiles/:subGroupId",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ProductFilesPage />
                    </RoleGuard>
                  )
            },
            {
              path: "/ProductImages/:subGroupId",
              element: (
                  <RoleGuard allowedRoles={['Admin']} >
                    <ProductImagePage />
                  </RoleGuard>
                )
          },
            {
                path: "/ManageProduct/:subGroupId",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ManageProductPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/ManageProduct",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ManageProductPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/SpareManager",
                element: (
                  <RoleGuard allowedRoles={['Admin']} >
                    <SparesManagerPage />
                  </RoleGuard>
                ),
              },
              {
                path: "/UserList",
                element: (
                  <RoleGuard allowedRoles={['Admin']} >
                    <UserListPage />
                  </RoleGuard>
                ),
              },              
            {
                path: "/SparePublisher",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <SparePublisherPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/Checkout",
                element: <CheckoutPage />,
            },            
            {
                path: "/ManageUser/:userId",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ManageUserPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/ManageUser",
                element: (
                    <RoleGuard allowedRoles={['Admin']} >
                      <ManageUserPage />
                    </RoleGuard>
                  )
            },
            {
                path: "/ExpenseApprovalList",
                element: (
                    <RoleGuard allowedRoles={['Admin', 'Manager', 'Auditor']} >
                        <ExpenseApprovalListPage />
                    </RoleGuard>
                )
            },
            {
                path: "/ExpenseReport",
                element: (
                    <RoleGuard allowedRoles={['Admin', 'Manager']} >
                        <ExpenseReportPage />
                    </RoleGuard>
                )
            },
            {
                path: "/OrderTracking",
                element: (
                    <UserRoleGuard allowedRoles={['Admin', 'Coordinator', 'Manager']} >
                        <OrderTrackingPage />
                    </UserRoleGuard>
                )
            },
            {
                path: "/ExpenseApprovalDetail/:requestId",
                element: (
                    <RoleGuard allowedRoles={['Manager']} >
                        <ExpenseRequestApprovalPage ReadOnly={false} />
                    </RoleGuard>
                )
            },
            {
                path: "/ExpenseAdminApprovalDetail/:tripId",
                element: (
                    <RoleGuard allowedRoles={['Admin', 'Auditor']} >
                        <ExpenseAdminApprovalPage ReadOnly={false} />
                    </RoleGuard>
                )
            },


            {
                path: "/MyRequest",
                element: <MyRequestPage />,
            },
            {
                path: "/MyRequestDetail/:requestId",
                element: <MyRequestDetailPage />,
            },
            {
                path: "/ChangePassword",
                element: <ChangePasswordPage />,
            },
            {
                path: "/NewExpenseRequest",
                element: <NewExpenseRequestPage />,
            },
            {
                path: "/MyExpenseRequest",
                element: <MyExpenseRequestPage />,
            },
            {
                path: "/MyExpenseRequestDetail/:requestId",
                element: <ExpenseRequestApprovalPage ReadOnly={ true} />,
            },

            {
                path: "/ServiceRequestApprovalList",
                element: (
                    <UserRoleGuard allowedRoles={['Coordinator', 'Manager', 'MD', 'Commercial']} >
                        <ServiceRequestApprovalListPage />
                    </UserRoleGuard>
                )
            },
            {
                path: "/ServiceRequestApproverDetail/:id",
                element: (
                    <UserRoleGuard allowedRoles={['Coordinator', 'Manager', 'MD', 'Commercial']} >
                        <ServiceRequestView isApproverView={true} />
                    </UserRoleGuard>
                )
            },
            {
                path: "/ServiceRequestReport",
                element: (
                    <UserRoleGuard allowedRoles={['Manager', 'Admin']} >
                        <ServiceRequestReportPage />
                    </UserRoleGuard>
                )
            },
            {
                path: "/NewServiceRequest",
                element: <NewServiceRequestPage />,
            },
            {
                path: "/NewMasterRequest",
                element: <NewMasterRequestPage />,
            },
            {
                path: "/MyMasterRequest",
                element: <MyMasterRequestPage />,
            },
            {
                path: "/MyMasterRequestDetail/:id",
                element: <MasterRequestView />,
            },
            {
                path: "/MasterRequestApprovalList",
                element: (
                    <UserRoleGuard allowedRoles={['Admin', 'Coordinator']}>
                        <MasterRequestApprovalListPage />
                    </UserRoleGuard>
                )
            },
            {
                path: "/MasterRequestApproverDetail/:id",
                element: (
                    <UserRoleGuard allowedRoles={['Admin', 'Coordinator']}>
                        <MasterRequestView isApproverView={true} />
                    </UserRoleGuard>
                )
            },
            {
                path: "/MasterRequestReport",
                element: (
                    <UserRoleGuard allowedRoles={['Admin', 'Coordinator']}>
                        <MasterRequestReportPage />
                    </UserRoleGuard>
                )
            },
            {
                path: "/MyServiceRequest",
                element: <MyServiceRequestPage />,
            },
            {
                path: "/MyServiceRequestDetail/:id",
                element: <ServiceRequestView />,
            },
            
            {
              path: "/unauthorized",
              element: <div><h2>403 - Unauthorized</h2><p>You do not have permission to view this page.</p></div>,
            }
        ]
    },
    {
        path: "login",
        element: <AppLogin />,
    },
    {
        path: "ChangePassword",
        element: <AppChangePassword />
    }    
]);
